import React from "react";
import { finApi, money } from "@/lib/financeApi";
import { Empty, ErrorBox, Loading, useLoad, when } from "@/components/nds/windows/finance/parts";
import { SPLIT_KEYS } from "@/components/nds/windows/finance/PaycheckForm";

export default function SplitTab({ resident }) {
  const [state, load] = useLoad(() => finApi.get("/paychecks", { resident_id: resident.id, status: "verified" }), [resident.id]);
  if (state.loading && !state.data) return <Loading testid="fin-split-loading" />;
  if (state.error) return <ErrorBox testid="fin-split-error" error={state.error} onRetry={load} />;
  const pc = state.data.paychecks[0];
  if (!pc) return <Empty testid="fin-split-empty">No verified paycheck yet.</Empty>;
  return (
    <div data-testid="fin-split-tab" className="p-5 space-y-4">
      <div className="flex flex-wrap items-baseline gap-3">
        <span className="text-nex-silver font-medium">{pc.employer || "Paycheck"}</span>
        <span className="font-mono text-[10px] text-nex-muted">{pc.pay_period_start} → {pc.pay_period_end} · verified {when(pc.verified_at)}</span>
        <span data-testid="fin-split-gross" className="ml-auto font-mono text-lg text-nex-gold">{money(pc.gross_amount)}</span>
      </div>
      <div className="space-y-2">
        {SPLIT_KEYS.map(([k, label, hint]) => {
          const v = pc.split[k] || 0;
          const pct = pc.gross_amount ? (v / pc.gross_amount) * 100 : 0;
          return (
            <div key={k} className="space-y-1">
              <div className="flex items-center gap-3 text-sm">
                <span className="text-nex-silver w-40">{label}</span>
                <span className="font-mono text-[10px] text-nex-muted">{hint}</span>
                <span data-testid={`fin-split-${k}`} className="ml-auto font-mono text-nex-silver">{money(v)}</span>
                <span className="font-mono text-[10px] text-nex-muted w-12 text-right">{pct.toFixed(0)}%</span>
              </div>
              <div className="h-1.5 bg-white/5 rounded-full overflow-hidden"><div className="h-full bg-nex-gold/70" style={{ width: `${pct}%` }} /></div>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-nex-muted">Tithe is recorded on the paycheck only and never posts a ledger row.</p>
    </div>
  );
}
